export class DashboardCount{
    patientTotalCount: number;
    userTotalCount: number;
    specialityTotalCount: number;
    servicelineTotalCount: number;
    stageWorkfolowTotalCount: number
}